import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, tap } from 'rxjs';
import { VersionMismatchDialogComponent } from '../components/version-mismatch-dialog/version-mismatch-dialog.component';

const clientVersionHeader = 'X-Fullyops-Version';
const applicationVersion = '10.1';
export const versionMismatchStatus = 418;

@Injectable({ providedIn: 'root' })
export class VersionCheckInterceptor implements HttpInterceptor {
  constructor(private dialog: MatDialog) {}

  private dialogPending = false;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const amendedReq = req.clone({
      headers: req.headers.append(clientVersionHeader, applicationVersion),
    });
    return next.handle(amendedReq).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err.status === versionMismatchStatus) {
            // show the dialog only once if multiple requests fail at once
            if (this.dialogPending) {
              return;
            }
            this.dialogPending = true;
            this.dialog
              .open<VersionMismatchDialogComponent, {}, boolean>(
                VersionMismatchDialogComponent,
              )
              .afterClosed()
              .subscribe((ok) => {
                this.dialogPending = false;
                if (ok) {
                  window.location.reload();
                }
              });
          }
        },
      }),
    );
  }
}
